var _rect, _path, _rect2, _rect3, _rect4, _rect5, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftworksHeaderLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#4A5568"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20 L16 24 L24 14",
    stroke: "#60A5FA",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 9,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 26,
    fontFamily: "'Nunito Sans', system-ui, -apple-system, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "currentColor"
  }, "\n    SHIFTWORKS\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftworksHeaderLogo);
export default __webpack_public_path__ + "static/media/shiftworks-header-logo.6962d3a92a37f7977ca11cddc8df9444.svg";
export { ForwardRef as ReactComponent };